import React, { useContext } from "react";
import { Menu2, Moon, Sun } from "tabler-icons-react";
import logo from "../assets/logodark.jpg";
import useDarkMode from "../utils/darkMode";
import { MenuContext } from "../context/menuContext";

function Header() {
	const [colorTheme, setTheme] = useDarkMode();
	const { dispatch } = useContext(MenuContext);

	return (
		<div className="absolute md:hidden top-0 h-[3rem] w-screen border-b border-b-slate-50 py-1 dark:border-b-darkborder">
			<div className="flex items-center justify-between px-5">
				<div className="flex space-x-2 items-center">
					<span
						className="cursor-pointer"
						onClick={() => dispatch({ type: "SHOW" })}>
						<Menu2 size={20} />
					</span>
					<img src={logo} alt="logo" className="w-10 h-10" />
					<span className="text-slate-600 dark:text-darktext font-medium">
						sheEQUIP
					</span>
				</div>
				<span className="flex space-x-2 items-center">
					<span
						onClick={() => setTheme(colorTheme)}
						className="border border-slate-500 dark:border-darkborder rounded-md p-[.09rem] cursor-pointer hover:bg-slate-500 hover:text-white">
						{colorTheme === "dark" ? (
							<Moon size={15} fill="black" />
						) : (
							<Sun size={15} fill="black" />
						)}
					</span>
					<span className="font-code text-xs bg-slate-100 dark:bg-darkbg border dark:border-darkborder px-1 rounded-md">
						admin
					</span>
				</span>
			</div>
		</div>
	);
}

export default Header;
